module.exports = __webpack_public_path__ + "media/images/favicons_staging/apple-touch-icon-180x180-c296e4373f475a90d02602983101a659.png";